class RecommendedProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onRenderCards();
  }

  onRenderCards() {
    const url = this.getAttribute("data-url");

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(
          ".recommended-products .recommended-products__slider"
        );
        if (recommendations) {
          document.querySelector(
            ".recommended-products .recommended-products__slider"
          ).innerHTML = recommendations.innerHTML;

          this.initCards();
          this.onColorUpdate();
          this.initSlider();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  initCards() {
    this.productCards = document.querySelectorAll(".product-card");

    this.productCards.forEach((card) => {
      const checkedInput = card.querySelector('[name^="color-"]:checked');
      if (checkedInput) {
        const selectedColor = checkedInput.value;
        this.updateProductInfo(card, selectedColor);
      }
    });
  }

  onColorUpdate() {
    this.productCards.forEach((card) => {
      const inputs = card.querySelectorAll('[name^="color-"]');
      inputs.forEach((input) => {
        input.addEventListener("change", () => {
          const selectedColor = input.value;
          this.updateProductInfo(card, selectedColor);
        });
      });
    });
  }

  updateProductInfo(card, selectedColor) {
    const productData = JSON.parse(
      card.querySelector(".product-json").innerHTML
    );
    const activeVariant = productData.variants.find((variant) =>
      variant.options.includes(selectedColor)
    );
    const cardImage = card.querySelector(".product-card__picture img");
    const currentPrice = card.querySelector(".product-card__current-price");
    const originalPrice = card.querySelector(".product-card__original-price");
    const productLinks = card.querySelectorAll(".product-card__link");

    if (activeVariant) {
      cardImage.src = activeVariant.featured_image;
      cardImage.alt = activeVariant.featured_image_alt;

      currentPrice.textContent = activeVariant.price;
      productLinks.forEach((link) => (link.href = activeVariant.url));

      if (originalPrice) {
        originalPrice.textContent = activeVariant.compare_at_price;
      }
    }
  }

  initSlider() {
    this.slider = this.querySelector(".recommended-products__slider");
    this.prevBtn = this.querySelector(".swiper-button-prev");
    this.nextBtn = this.querySelector(".swiper-button-next");

    this.swiper = new Swiper(this.slider, {
      spaceBetween: 10,
      slidesPerView: 2,
      grabCursor: true,
      autoHeight: true,

      navigation: {
        nextEl: this.nextBtn,
        prevEl: this.prevBtn,
      },

      breakpoints: {
        450: {
          spaceBetween: 12,
          slidesPerView: 2,
        },
        767: {
          spaceBetween: 12,
          slidesPerView: 2.5,
        },
        1200: {
          spaceBetween: 15,
          slidesPerView: 4,
        },
      },
    });
  }
}

customElements.define("recommended-products", RecommendedProducts);
